export function normalizeUrl(url: string): string {
    if (!url) {
        return "";
    }
    if (/^https?:\/\//i.test(url)) {
        return url;
    }
    if (url.startsWith("//")) {
        return `${globalThis.location?.protocol ?? "https:"}${url}`;
    }
    return `https://${url}`;
}

export function buildPreviewUrl(url: string): string {
    const normalized = normalizeUrl(url);
    try {
        const origin = typeof window !== "undefined" && window.location ? window.location.origin : "https://wsrv.nl";
        const previewUrl = new URL("//wsrv.nl/", origin);
        previewUrl.searchParams.set("url", normalized.replace(/^https?:\/\//, ""));
        previewUrl.searchParams.set("w", "400");
        previewUrl.searchParams.set("h", "400");
        previewUrl.searchParams.set("fit", "cover");
        return previewUrl.toString().replace(`${previewUrl.protocol}//`, "//");
    } catch {
        return normalized;
    }
}
